import React from 'react'
import { SelectChangeEvent, Typography } from '@mui/material'

import Box from 'components/Common/Box'

import { Option } from 'models/Select'

import { StyledSelect } from './styles'

type SelectCellProps = {
  label: string
  value?: string
  endAdornment?: string
  startAdornment?: React.ReactNode
  edit?: boolean
  onChange?: (event: SelectChangeEvent<unknown>) => void
  name?: string
  options: Option[]
  defaultOption: Option
}

const SelectCell = ({
  label,
  value,
  endAdornment,
  edit,
  onChange,
  name,
  options,
  startAdornment,
  defaultOption,
}: SelectCellProps) => {
  const renderOption = (): string => {
    if (options.length === 0) return defaultOption.name
    return options.find((option) => option.value === value)!.name
  }

  return (
    <Box>
      <Typography variant="body1">{label}</Typography>
      {!edit ? (
        <Box alignItems="center" display="flex">
          {startAdornment}
          <Typography variant="body2">{renderOption()}</Typography>
        </Box>
      ) : (
        <StyledSelect
          name={name}
          value={value}
          onChange={onChange}
          endAdornment={endAdornment}
          variant="outlined"
          label={label}
          options={options.length > 0 ? options : [defaultOption]}
          formControlStyles={{
            width: '100%',
            height: '29px',
          }}
        />
      )}
    </Box>
  )
}

export default SelectCell
